import { render, staticRenderFns } from "./cube.vue?vue&type=template&id=665bbc34&"
import script from "./cube.vue?vue&type=script&lang=js&"
export * from "./cube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports